import { ContentCopy, DeleteOutline, DriveFileRenameOutline } from "@mui/icons-material"
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"

export interface TabActionsMenuProps {
  anchorEl: HTMLElement | null
  open: boolean
  onClose: () => void
  onDuplicate: () => void
  // True while a duplicate from this menu is in flight — disables the item so a reopen-and-click
  // during a slow network can't mint a second copy. [APP-3309]
  isDuplicating: boolean
  // Rename the active dashboard instance (opens the rename dialog).
  onRename: () => void
  // Delete the active dashboard instance (opens the confirm dialog).
  onDelete: () => void
}

// The active tab's "⋮" actions menu. Presentational — actions are delegated via callback.
export default function TabActionsMenu({
  anchorEl,
  open,
  onClose,
  onDuplicate,
  isDuplicating,
  onRename,
  onDelete,
}: TabActionsMenuProps) {
  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem
        onClick={() => {
          onRename()
          onClose()
        }}
      >
        <ListItemIcon><DriveFileRenameOutline fontSize="small" /></ListItemIcon>
        <ListItemText primary="Rename" />
      </MenuItem>
      <MenuItem
        disabled={isDuplicating}
        onClick={() => {
          onDuplicate()
          onClose()
        }}
      >
        <ListItemIcon><ContentCopy fontSize="small" /></ListItemIcon>
        <ListItemText primary="Duplicate" />
      </MenuItem>
      <MenuItem
        onClick={() => {
          onDelete()
          onClose()
        }}
        sx={{ color: "error.main" }}
      >
        <ListItemIcon><DeleteOutline fontSize="small" color="error" /></ListItemIcon>
        <ListItemText primary="Delete" />
      </MenuItem>
    </Menu>
  )
}
